import React, { useState } from 'react';
import { FiEdit2, FiTrash2, FiPlus } from 'react-icons/fi';
import Button from '../common/Button';
import { Card, CardHeader, CardTitle, CardContent } from '../common/Card';

const JDList = ({ jds, onEdit, onDelete, onAdd, onSelect, selectedJdId }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // 过滤JD列表
  const filteredJds = jds.filter(jd => 
    jd.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Card className="h-full">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-xl">职位描述列表</CardTitle>
        <Button
          onClick={onAdd}
          size="sm"
          className="flex items-center gap-1"
        >
          <FiPlus className="h-4 w-4" />
          添加JD
        </Button>
      </CardHeader>
      <CardContent>
        <div className="mb-4">
          <input
            type="text"
            placeholder="搜索JD..."
            className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        
        <div className="space-y-2 max-h-[calc(100vh-280px)] overflow-y-auto pr-2">
          {filteredJds.length > 0 ? (
            filteredJds.map((jd) => (
              <div
                key={jd.id}
                className={`p-3 rounded-md border cursor-pointer transition-colors ${
                  selectedJdId === jd.id
                    ? 'bg-primary/10 border-primary'
                    : 'hover:bg-accent'
                }`}
                onClick={() => onSelect(jd.id)}
              >
                <div className="flex items-center justify-between">
                  <h3 className="font-medium truncate">{jd.title}</h3>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onEdit(jd);
                      }}
                      className="p-1 rounded-md hover:bg-accent"
                      aria-label="编辑"
                    >
                      <FiEdit2 className="h-4 w-4" />
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(jd.id);
                      }}
                      className="p-1 rounded-md hover:bg-destructive/10 hover:text-destructive"
                      aria-label="删除"
                    >
                      <FiTrash2 className="h-4 w-4" />
                    </button>
                  </div>
                </div>
                <p className="text-sm text-muted-foreground mt-1">
                  创建于: {new Date(jd.created_at).toLocaleDateString()}
                </p>
              </div>
            ))
          ) : (
            <div className="text-center py-8 text-muted-foreground">
              {searchTerm ? '没有找到匹配的JD' : '暂无JD，请添加'}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default JDList;
